/**
 *Created by jmmartinez on 05/08/2021

 * 06/05/2022 v.1.1 Fusion Sidemur y Planifikator
 * 01/06/2022 v.1.2 Modificado onCloseColorEditor para obtener el nombre del campo.
 *                  Modificado onForeignAceptado  para obtener el nombre del campo.
 * 13/06/2022 v.1.3 Añadido gestión de editores personalizados
 * 14/06/2022 v.1.4 En onCloseEditor añadimos el parámetro valor2.
 *                  En la llamada a  onCloseEditor, pasamos noGuardarEnBDD según lo digan las propiedades.
 * 06/07/2022 v.1.5 En RenderForeignEditor, en la llamada a DialogoSelectorLista, la propiedad GridColumnaCampo se rellena con el parámetro que viene "columnaCampo"
 * 28/07/2022 v.1.6 En onCloseEditor, cambiamos la comparacion "if(valor)" por "if(valor != undefined)" para que tome el valor "".
 * 29/07/2022 v.1.7 En RenderForeignEditor, añadimos el uso de la propiedad anchoColumna
 * 19/10/2022 v.1.8 En RenderForeignEditor, añadimos onPropiedadesServicio
 * 21/11/2022 v.1.9 En las propiedades de EditorExterno añadimos onAceptar, para llamar al editorExterno y en el retorno hacer acciones.
 *                      El uso de onAceptar ecluye el funcionamiento normal integrado con FormularioGrid.
 *                      En OnCloseEditor, al finalizar, según esté definido onACeptar o no, llamamos a onAceptar o a gridRDG.onGridRowsChange.
 * 29/03/2023 v.1.10 En onClose, añadida la condicion "!editorExternoColumn.editorExterno" al OR para ver si se llama a editorExternoColumn.editorExterno.onAceptar
 * 17/04/2023 v.1.11 Paso a Componente
 *                   Nueva propiedad PEDIRCONFIRMACION y su uso interno.
 *                   Modificación para que al hacer cancelar en el Editor se cancele.
 * 18/04/2023 v.1.12 Añadida nueva propiedad ONPEDIRCONFIRMACION y su uso interno
 * 21/04/2023 v.1.13 Añadido editorBooleano
 * 29/04/2023 v.1.14 En el método UsaEditorExterno, incluimos CELLTIPO_SINO
 * 08/05/2023 v.1.16 En renderListaEditor añadido el uso de editorExternoColumn.titulo y editorExternoColumn.alto
 * 26/07/2023 v.1.17 En onCloseEditor, en las condiciones de pedirConfirmacion, añadimos delante la existencia de editorExternoColumn.editorExterno
 *
 * 19/06/2024 v.1.18 En renderListaEditor, añadimos la condición editorExternoColumn.editorExterno && para calcular el titulo  y el alto.
 * */

import React from 'react'
import {EDITOREXTERNO_COLOR, EDITOREXTERNO_FOREIGN, EDITOREXTERNO_LISTA, EDITOREXTERNO_PERSONALIZADO, EDITOREXTERNO_BOOLEANO} from "./GridRDG";
import {Button, Dialog, Intent, Tooltip} from "@blueprintjs/core";
import {SketchPicker} from "react-color";
import DialogoSelectorLista from "../ej2/UI/DialogoSelectorLista";
import {getCampoForeignCodigo, getRaizForeign} from "../ej2/utils/ForeignUtils";
import * as Classes from "@blueprintjs/core/lib/esm/common/classes";
import EditorLista from "./EditorLista";
import EditorBooleano from "./EditorBooleano";
import {
    CELLTIPO_CADENA, CELLTIPO_CADENAFOREIGN,
    CELLTIPO_COLOR,
    CELLTIPO_FOREIGN,
    CELLTIPO_LISTA,
    CELLTIPO_PERSONALIZADO, CELLTIPO_SINO
} from "../ej2/UI/TiposCeldas";
import Dialogo from "../blueprint/Dialogo";
import PropTypes from "prop-types";
import ColorPicker from "../color/ColorPicker";


class EditorExterno extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            mostrarDialogoConfirmacion: false,

        }
    }


//---------------------------------------------------------------------------
// RENDERIZADORES
//---------------------------------------------------------------------------

    renderListaEditor = () => {
        const {mostrarDialogoConfirmacion} = this.state;
        const {gridRDG} = this.props;
        const {mostrarEditorExterno, editorExternoColumn, editorExternoObjeto} = this.props.gridRDG.state;
        let mostrar = mostrarEditorExterno != null && mostrarEditorExterno != undefined;

        //console.log(" ++++++ RENDERLISTA EDITOR +++++")
        //console.log("mostrarDialogoConfirmacion: ", mostrarDialogoConfirmacion);
        //console.log("editorExternoColumn: ", editorExternoColumn);
        //console.log("editorExternoColumn.alto: ", editorExternoColumn.editorExterno.alto);

        let titulo= editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.titulo ? editorExternoColumn.editorExterno.titulo : "Modificación";
        let alto= editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.alto ? editorExternoColumn.editorExterno.alto : '100px';

        return (
            <Dialog icon="git-push"
                    onClose={() => {
                        this.onCloseEditor(null, gridRDG)
                    }}
                    isOpen={mostrar}
                    usePortal={true}
                    style={{width: '20%'}}
                    canOutsideClickClose={false}
                    autofocus={true}
            >
                <div className={Classes.DIALOG_BODY} style={{height: alto}}>
                    {mostrarDialogoConfirmacion &&
                    <Dialogo titulo={"Modificación"} mensaje={"¿Desea realizar la modificación?"} tipo={"PREGUNTASINO"}
                             onQuestion={this.respuestaDialog}
                             onClose={() => {
                                 this.setState({mostrarDialogoConfirmacion: false})
                             }}
                    />
                    }

                    <EditorLista gridRDG={gridRDG}
                                 editorExternoColumn={editorExternoColumn}
                                 editorExternoObjeto={editorExternoObjeto}
                                 onCloseEditor={this.onCloseEditor}
                    />
                </div>
            </Dialog>

        )
    }

    renderColorEditor = () => {
        const {gridRDG} = this.props;
        const {mostrarEditorExterno} = this.props.gridRDG.state;
        let mostrar = mostrarEditorExterno != null && mostrarEditorExterno != undefined;
        return (
            <Dialog icon="git-push"
                    onClose={() => {
                        this.onCloseEditor(null, gridRDG)
                    }}
                    isOpen={mostrar}
                    usePortal={true}
                    style={{width: "120px"}}
            >
                <SketchPicker
                    style={{margin: 10}}
                    onChange={(color) => {
                        console.log("SketchPicker: color: ", color);
                        this.onCloseEditor(color.hex, gridRDG);
                    }}/>
            </Dialog>
        )
    }

    renderPersonalizadoEditor = () => {
        const {gridRDG} = this.props;
        const {mostrarEditorExterno, editorExternoColumn, editorExternoObjeto} = this.props.gridRDG.state;
        let mostrar = mostrarEditorExterno != null && mostrarEditorExterno != undefined;
        //console.log("*** renderPersonalizadoEditor");
        //console.log("editorExternoColumn: ", editorExternoColumn);
        //console.log("gridRDG: ", gridRDG);

        let titulo = editorExternoColumn.titulo;
        return (
            <Dialog icon="git-push"
                    onClose={() => {
                        this.onCloseEditor(null, gridRDG)
                    }}
                    isOpen={mostrar}
                    usePortal={true}
                    style={{width: editorExternoColumn.editorExterno.editorWidth}}
                    canOutsideClickClose={false}
                    autofocus={true}
            >
                <div className={Classes.DIALOG_BODY} style={{height: editorExternoColumn.editorExterno.editorHeight}}>
                    {editorExternoColumn.editorExterno.getEditorRender(editorExternoColumn, editorExternoObjeto, gridRDG, this.onCloseEditor)}
                </div>

                {editorExternoColumn.editorExterno.editorMostrarPie &&
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Tooltip content="Aceptar">
                            <Button intent={Intent.SUCCESS} icon="tick-circle"
                                    onClick={() => this.onCloseEditor(null, gridRDG)}>Aceptar</Button>
                        </Tooltip>
                        <Tooltip content="Cancelar">
                            <Button intent={Intent.DANGER} icon="delete"
                                    onClick={() => this.onCloseEditor(null, gridRDG)}>Cancelar</Button>
                        </Tooltip>
                    </div>
                </div>
                }

            </Dialog>
        )
    }

    renderForeignEditor = () => {
        const {gridRDG} = this.props;
        const {mostrarEditorExterno, editorExternoColumn, editorExternoObjeto} = this.props.gridRDG.state;
        const {usarFiltros35} = this.props.gridRDG.props;
        let mostrar = mostrarEditorExterno != null && mostrarEditorExterno != undefined;
        let clase = editorExternoColumn.editorExterno.clase;
        let urlServicioRestful = editorExternoColumn.editorExterno.urlServicioRestful;
        let columnaCampo = editorExternoColumn.editorExterno.columnaCampo ? editorExternoColumn.editorExterno.columnaCampo : "nombre";
        let columnasAdicionales = editorExternoColumn.editorExterno.columnasAdicionales;
        let onPropiedadesServicio = editorExternoColumn.editorExterno.onPropiedadesServicio;
        let onCalcularFiltro = editorExternoColumn.editorExterno.onCalcularFiltro;
        //console.log("onCalcularFiltro: ", onCalcularFiltro);

        let condicionesCalculadas = null;
        if (onCalcularFiltro)
            condicionesCalculadas = onCalcularFiltro(editorExternoColumn, editorExternoObjeto);
        /*
        console.log("RENDER FOREIGN EDITOR");
        console.log("editorExternoColumn:", editorExternoColumn);
        console.log("editorExternoColumn.editorExterno: ", editorExternoColumn.editorExterno);
        console.log("mostrar: ", mostrar);
        console.log("clase: ", clase);
        console.log("columnaCampo: ", columnaCampo);
        console.log("condicionesCalculadas: ", condicionesCalculadas);
        */

        return (
            <DialogoSelectorLista //datos={datosForeign}
                id="dslForeign"
                style={{width: 200}}
                opened={mostrar}
                //gridColumnaCampo={"nombre"}
                //gridColumnaTitulo={"nombre"}
                gridColumnaCampo={columnaCampo}
                gridColumnasAdicionales={columnasAdicionales}
                //gridColumnaTitulo={"codigoid"}
                onAceptado={(foreign) => this.onCloseEditor(foreign, gridRDG)}
                onCancelado={() => this.onCloseEditor(null, gridRDG)}
                clase={clase}
                urlServicioRestful={urlServicioRestful}
                usarFiltros35={usarFiltros35}
                tipoGrid="reactdatagrid"
                anchoColumna={editorExternoColumn.editorExterno.anchoColumna}
                onPropiedadesServicio={onPropiedadesServicio}

                condiciones={condicionesCalculadas}
            />
        )
    }

    renderBooleanoEditor = () => {
        const {mostrarDialogoConfirmacion} = this.state;
        const {gridRDG} = this.props;
        const {mostrarEditorExterno, editorExternoColumn, editorExternoObjeto} = this.props.gridRDG.state;
        let mostrar = mostrarEditorExterno != null && mostrarEditorExterno != undefined;

        console.log(" ++++++ RENDER BOOLEANO EDITOR +++++")
        console.log("mostrarDialogoConfirmacion: ", mostrarDialogoConfirmacion);

        let titulo = editorExternoColumn.titulo;
        return (
            <Dialog icon="git-push"
                    onClose={() => {
                        this.onCloseEditor(null, gridRDG)
                    }}
                    isOpen={mostrar}
                    usePortal={true}
                    style={{width: '20%'}}
                    canOutsideClickClose={false}
                    autofocus={true}
            >
                <div className={Classes.DIALOG_BODY} style={{height: '100px'}}>
                    {mostrarDialogoConfirmacion &&
                    <Dialogo titulo={"Modificación"} mensaje={"¿Desea realizar la modificación?"} tipo={"PREGUNTASINO"}
                             onQuestion={this.respuestaDialog}
                             onClose={() => {
                                 this.setState({mostrarDialogoConfirmacion: false})
                             }}
                    />
                    }

                    <EditorBooleano gridRDG={gridRDG}
                                 editorExternoColumn={editorExternoColumn}
                                 editorExternoObjeto={editorExternoObjeto}
                                 onCloseEditor={this.onCloseEditor}
                    />
                </div>
            </Dialog>

        )
    }
    // ------------------------------------------------------------------------------------
    // ACCIONS
    // ------------------------------------------------------------------------------------

    onCloseEditor = (newValor) => {
        const {gridRDG} = this.props;
        const {editorExternoColumn} = gridRDG.state;

        /*
        console.log("--------------");
        console.log("XXXX onClosePersonalizadoEditor  XXX");
        console.log("editorExternoColumn: ", editorExternoColumn);
        console.log("newValor: ", newValor);
        console.log("gridRDG: ", gridRDG);
        console.log("editorExternoColumn.editorExterno: ", editorExternoColumn.editorExterno);
        if (editorExternoColumn.editorExterno)
            console.log("editorExternoColumn.editorExterno.onPedirConfirmacion: ", editorExternoColumn.editorExterno.onPedirConfirmacion);
        console.log("--------------");
        */

        let pedirConfirmacion = editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.pedirConfirmacion ? editorExternoColumn.editorExterno.pedirConfirmacion : false;
        if (editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.onPedirConfirmacion)
            pedirConfirmacion= editorExternoColumn.editorExterno.onPedirConfirmacion(newValor);

        console.log("pedirConfirmacion: ", pedirConfirmacion);

        if (newValor != null) {
            this.setState({valor: newValor},
                () => {
                    if (pedirConfirmacion && Boolean(pedirConfirmacion))
                        this.setState({mostrarDialogoConfirmacion: true});
                    else
                        this.modificarCampo();
                }
            );
        }
        //Interpretamos como cancelar
        else{
            gridRDG.setState({mostrarEditorExterno: null});
        }



    }

    modificarCampo = () => {
        const {gridRDG} = this.props;
        const {valor, valor2} = this.state;
        const {datosOrdenados, cellSelected, editorExternoColumn, editorExternoObjeto} = gridRDG.state;
        gridRDG.setState({mostrarEditorExterno: null});

        /*
        console.log("--------------");
        console.log("XXXX modificarCampo  XXX");
        console.log("editorExternoColumn: ", editorExternoColumn);
        console.log("editorExternoObjeto: ", editorExternoObjeto);
        console.log("valor: ", valor);
        console.log("valor2: ", valor2);
        console.log("--------------");
        */

        if (valor != undefined) {
            //indentificamos el campo:
            //Tenemos dos opciones según el tipo de editorExternoColumn se haya mandando:
            let campo = editorExternoColumn.key;
            if (!campo)
                campo = editorExternoColumn.columnKey;
            if (!campo)
                campo = editorExternoColumn.campo;
            //Asignamos el campo con el valor de campoDestino si existe, pq tiene precedencia.
            if (editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.campoDestino)
                campo = editorExternoColumn.editorExterno.campoDestino;

            //Si fuera un foreign tenemos que limpiar campos artificiales:
            if (editorExternoColumn.tipo == CELLTIPO_FOREIGN || editorExternoColumn.tipo == CELLTIPO_CADENAFOREIGN) {
                delete valor.rowIdx;
            }

            //modificamos el campo con el valor
            datosOrdenados[cellSelected.rowIdx][campo] = valor;
            if (editorExternoColumn.tipo == CELLTIPO_CADENAFOREIGN) {
                let campoCadena = editorExternoColumn.editorExterno.campoDestinoCadena;
                datosOrdenados[cellSelected.rowIdx][campoCadena] = valor.nombre;
            }


            //Si hay un segundo campo que actualzar
            if (valor2 && editorExternoColumn.editorExterno.campoDestino2)
                datosOrdenados[cellSelected.rowIdx][editorExternoColumn.editorExterno.campoDestino2] = valor2;

            let infoModificado = {
                indexes: [cellSelected.rowIdx],
                column: editorExternoColumn
            }

            //console.log("+++++++++++ editorExternoColumn.editorExterno: ", editorExternoColumn.editorExterno);
            let noGuardarEnBDD = editorExternoColumn.editorExterno && editorExternoColumn.editorExterno.noGuardarEnBDD && Boolean(editorExternoColumn.editorExterno.noGuardarEnBDD);
            //console.log("+++++++++++ noGuardarEnBDD: ", noGuardarEnBDD );

            //Comprobamos que no se haya evitado la llamada a guardar objeto explicitamente.
            //Llamamos explicitamente a onGridRowsChange para que se guarde la info.
            //console.log("+++++++++++ noGuardarEnBDD: ", editorExternoColumn.editorExterno.noGuardarEnBDD);
            if (!editorExternoColumn.editorExterno || !editorExternoColumn.editorExterno.onAceptar) {
                gridRDG.onGridRowsChange(datosOrdenados, infoModificado, true, noGuardarEnBDD);
            }
            else {
                //Llamamos a onAceptar
                editorExternoColumn.editorExterno.onAceptar(editorExternoObjeto, valor);
            }
        }
    }

    anularCampo= () => {
        console.log("ANULAR CAMPO");
        const {gridRDG} = this.props;
        gridRDG.setState({mostrarEditorExterno: null});
    }

    respuestaDialog = (respuesta) => {
        //console.log("RespuestaDialog: ");
        //console.log("respuesta: ", respuesta);
        this.setState({mostrarDialogoConfirmacion: false}, () => {
                if (Boolean(respuesta))
                    this.modificarCampo();
                else
                    this.anularCampo();
            }
        );
    }

    onForeignAceptado = (foreign, gridRDG) => {
        const {datosOrdenados, cellSelected, editorExternoColumn} = gridRDG.state;
        const {usarFiltros35} = gridRDG.props;

        //console.log("ON FOREIG ACEPTADO");
        //console.log("foreign: ", foreign);

        gridRDG.setState({mostrarEditorExterno: null});

        //modificamos el valor
        let rowIdx = cellSelected.rowIdx;

        //Tenemos dos opciones según el tipo de editorExternoColumn se haya mandando:
        let campo = editorExternoColumn.key;
        if (!campo)
            campo = editorExternoColumn.columnKey;

        if (usarFiltros35) {
            //Asignamos el campo codigo: personalCodigo= 2
            let campoModificar = getCampoForeignCodigo(campo);
            datosOrdenados[rowIdx][campoModificar] = foreign.codigo;

            //Para que se refresque el grid sin necesidad de recargar, modificamos el campo foreign, y en la clave de la clase ponemos el foreing
            //.foreign."com.ej2sistemas.cDepartamento"= {foreing}
            let clase = getRaizForeign(campo);
            datosOrdenados[rowIdx].foreign[clase] = foreign;

            //Eliminamos el campo que se ha creado del tipo caracteristicaCodigo.nombre
            //delete datosOrdenados[rowIdx][editorExternoColumn.key];
        } else {

        }

        let infoModificado = {
            indexes: [cellSelected.rowIdx],
            column: editorExternoColumn
        }
        //Llamamos explicitamente a onGridRowsChange para que se guarde la info.
        gridRDG.onGridRowsChange(datosOrdenados, infoModificado, true);

    }




    // ------------------------------------------------------------------------------------
    //Render-----
    // ------------------------------------------------------------------------------------

    render () {
        //console.log("!!!! renderEditorExterno");
        //console.log("this.props: ", this.props);
        const {gridRDG} = this.props;
        //console.log("gridRDG: ", gridRDG);
        const {mostrarEditorExterno} = gridRDG.state;
        //console.log("mostrarEditorExterno: ", mostrarEditorExterno);


        switch (mostrarEditorExterno) {
            case EDITOREXTERNO_LISTA:
                return this.renderListaEditor();
            case EDITOREXTERNO_COLOR:
                return this.renderColorEditor();
            case EDITOREXTERNO_FOREIGN:
                return this.renderForeignEditor();
            case EDITOREXTERNO_PERSONALIZADO:
                return this.renderPersonalizadoEditor();
            case EDITOREXTERNO_BOOLEANO:
                return this.renderBooleanoEditor();
        }
    }


}

EditorExterno.propTypes = {
    gridRDG: PropTypes.object,
}

export default EditorExterno

// ------------------------------------------------------------------------------------------------------
// FUNCIONES
// ------------------------------------------------------------------------------------------------------
export const usaEditorExterno= (tipo) => {
    switch (tipo) {
        case CELLTIPO_LISTA:
        case CELLTIPO_COLOR:
        case CELLTIPO_PERSONALIZADO:
        case CELLTIPO_FOREIGN:
        case CELLTIPO_SINO:
            return true;
        default:
            return false;
    }
}

export const onListaImagenImagenCambiada= (newValor, column, gridGDR) => {
    const {datosOrdenados, cellSelected} = gridGDR.state;

    datosOrdenados[cellSelected.rowIdx][column.key]= newValor;
    let infoModificado= {
        indexes: [cellSelected.rowIdx],
        column: column
    }
    //Llamamos explicitamente a onGridRowsChange para que se guarde la info.
    gridGDR.onGridRowsChange(datosOrdenados, infoModificado, true);
}



